import React, { useEffect, useState }from "react";
import { useNavigate } from "react-router-dom";
import "./HomeContent.css";
import CardComponent from "./CardComponent";
import ShopCollections from "./ShopCollections";
import OffersMarquee from "./OffersMarquee";
import TopDeals from "./TopDeals";
import RatingSection from "./SlidingRatings";
import PlantLogo from "../assets/plants.jpeg";
import ProductLogo from "../assets/products.jpeg";
import DeskLogo from "../assets/desk.jpeg";
// import InfoLinks from "./InfoLinks";
const API_BASE_URL = process.env.REACT_APP_BASE_URL;


function HomeContent() {
  const [carouselImages, setCarouselImages] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCarouselImages = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/account/dashboard-images/?type=slider`);
        if (response.ok) {
          const data = await response.json();
          setCarouselImages(data);
        } else {
          console.error("Failed to fetch carousel images");
        }
      } catch (error) {
        console.error("Error fetching carousel images:", error);
      }
    };

    fetchCarouselImages();
  }, []);

   // Handle Category Click
   const handleCategoryClick = (category) => {
    navigate(`/products/${category}`);
  };

  return (
    <div className="container-fluid home-content">
      {/* Hero Section with Carousel */}
      {/* <div id="carouselExample" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src="https://via.placeholder.com/1920x500" className="d-block w-100" alt="..." />
          </div>
          <div className="carousel-item">
            <img src="https://via.placeholder.com/1920x500" className="d-block w-100" alt="..." />
          </div>
          <div className="carousel-item">
            <img src="https://via.placeholder.com/1920x500" className="d-block w-100" alt="..." />
          </div>
        </div> */}
        <div id="carouselExample" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          {carouselImages.length > 0 ? (
            carouselImages.map((image, index) => (
              <div
                key={image.id}
                className={`carousel-item ${index === 0 ? "active" : ""}`}
              >
                <img
                  src={image.image}
                  className="d-block w-100 home-img"
                  alt={`Slide ${index + 1}`}
                />
              </div>
            ))
          ) : (
            <div className="carousel-item active">
              <img
                src="https://via.placeholder.com/1920x500"
                className="d-block w-100"
                alt="Placeholder"
              />
            </div>
          )}
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExample"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExample"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>

      {/* Welcome Section */}
      <section className="welcome-section text-center container py-5">
        <h2>Welcome to Vastu Salahkar</h2>
        <p>Your one-stop solution for all Vastu Plants, Products, and Remedies.</p>
      </section>

      <OffersMarquee />

      {/* Services Section */}
      <section className="container services-section py-5">
        <h3 className="text-center mb-4">Our Services</h3>
        <div className="row justify-content-center">
          <CardComponent
            onClick={() => handleCategoryClick("plants")}
            title="Vastu Plants"
            description="Discover a wide range of Vastu plants to enhance positive energy."
            image={PlantLogo}
          />
          <CardComponent
            onClick={() => handleCategoryClick("products")}
            title="Vastu Products"
            description="Explore our curated Vastu products for your spaces."
            image={ProductLogo}
          />
          <CardComponent
            onClick={() => handleCategoryClick("desk_energy")}
            title="Desk Energy"
            description="Get expert Vastu consultations tailored to your needs."
            image={DeskLogo}
          />
        </div>
      </section>

      <ShopCollections />

      <TopDeals />

      <RatingSection />

      {/* <InfoLinks /> */}

      {/* Contact Section */}
      {/* <section className="contact-section text-center container py-5">
        <h3>Contact Us</h3>
        <p>For queries, feel free to reach out at <a href="mailto:vastuauraaligners@gmail.com">vastuauraaligners@gmail.com</a></p>
      </section> */}
    </div>
  );
}

export default HomeContent;
